import { render, staticRenderFns } from "./IntegralView.vue?vue&type=template&id=3e89a02d&scoped=true"
import script from "./IntegralView.vue?vue&type=script&lang=js"
export * from "./IntegralView.vue?vue&type=script&lang=js"
import style0 from "./IntegralView.vue?vue&type=style&index=0&id=3e89a02d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e89a02d",
  null
  
)

export default component.exports